import React from 'react';
import PropTypes from 'prop-types';
import { createFragmentContainer, graphql } from 'react-relay';

import styles from './SbSharedContentModulePromo.scss';

const DEFAULT_MAX_IMG_WIDTH = 1018;
const defaultBannerImg =
    'https://a.1stdibscdn.com/dist/adhoc/dealer-storefront-cms/promo-banner.jpg';

function SbSharedContentModulePromoComponent({ browseContentModule, renderImage }) {
    const { photo, pillText, headline, subtext, link, linkText } = browseContentModule;

    const bannerImg = photo || defaultBannerImg;

    const renderImageProps = {
        src: `${bannerImg}?width=${DEFAULT_MAX_IMG_WIDTH}`,
        imgClassName: styles.image,
        alt: headline || pillText || '',
    };

    return (
        <div className={styles.wrapper}>
            {renderImage && (
                <div className={styles.imgWrapper}>{renderImage(renderImageProps)}</div>
            )}
            <div className={styles.moduleWrapper}>
                {pillText && (
                    <div className={styles.marketingPill}>
                        <div className={styles.marketingPillInner}>{pillText}</div>
                    </div>
                )}
                {headline && <div className={styles.headline}>{headline}</div>}
                {subtext && <div className={styles.subtext}>{subtext}</div>}
                {link && linkText && (
                    <a
                        href={link}
                        className={styles.link}
                        target="_blank"
                        rel="noopener noreferrer"
                    >
                        {linkText}
                    </a>
                )}
            </div>
        </div>
    );
}

SbSharedContentModulePromoComponent.propTypes = {
    browseContentModule: PropTypes.object.isRequired,
    renderImage: PropTypes.func,
};

export const SbSharedContentModulePromo = createFragmentContainer(
    SbSharedContentModulePromoComponent,
    {
        browseContentModule: graphql`
            fragment SbSharedContentModulePromo_browseContentModule on ContentModulePromo {
                photo
                pillText
                headline
                subtext
                link
                linkText
            }
        `,
    }
);
